import { render, staticRenderFns } from "./Remisiones.vue?vue&type=template&id=000dea9b&"
import script from "./Remisiones.vue?vue&type=script&lang=js&"
export * from "./Remisiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports